export default __webpack_public_path__ + "static/media/Cap.474e6898.png";